import { observer } from 'mobx-react';
import { PickupDropoffOption } from '@bringg/types';

import { tooltipProvider } from '../tooltip-render-provider';
import useTaskTooltipTranslation from './use-task-tooltip-translation';

interface TaskTypeProps {
	pickupDropoffOptions: PickupDropoffOption;
}
const TaskType = ({ pickupDropoffOptions }: TaskTypeProps) => {
	const { taskType, pickup, dropOff } = useTaskTooltipTranslation();

	const getValue = () => {
		switch (pickupDropoffOptions) {
			case PickupDropoffOption.PICKUP:
				return pickup;
			case PickupDropoffOption.DROPOFF:
				return dropOff;
			case PickupDropoffOption.BOTH:
				return `${pickup}, ${dropOff}`;
		}
	};

	return tooltipProvider.renderText(taskType, getValue());
};

export default observer(TaskType);
